import { render } from "./kcjr.vue?vue&type=template&id=6bab1236&scoped=true"
import script from "./kcjr.vue?vue&type=script&lang=js"
export * from "./kcjr.vue?vue&type=script&lang=js"

import "./kcjr.vue?vue&type=style&index=0&id=6bab1236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bab1236"]])

export default __exports__